module.exports = __webpack_public_path__ + "static/media/right-menu-settings-icon.2ed5e009.svg";